<template>
  <div class="activationData">
    <div class="col-12 row text-center mx-0 table-responsive" style="">
      <!-- <table
        class="table table-bordered activationData-table-detail activationData-table-detail-select"
        style="border: none"
      >
        <tbody>
          <tr style="background-color: transparent">
            <td style="border: none">
              <b-form-select
                style="
                  line-height: 22px;
                  font-size: 16px;
                  border: 2px solid #427ace;
                  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                  color: rgb(95, 95, 95);
                "
              ></b-form-select>
            </td>
            <td style="border: none">
              <b-form-select
                style="
                  line-height: 22px;
                  font-size: 16px;
                  border: 2px solid #427ace;
                  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                  color: rgb(95, 95, 95);
                "
              ></b-form-select>
            </td>
          </tr>
        </tbody>
      </table> -->
      <b-table
        :items="activationDataItem"
        :fields="activationDataFields"
        sticky-header="240px"
        :no-border-collapse="true"
        class="activationData-table-detail activationData-table-detail-select"
      ></b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "activationData",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      activationDataFields: "activationData/get_activationDataFields",
      activationDataItem: "activationData/get_activationDataItem",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
    }),
  },
};
</script>

<style>
</style>
<style lang="scss">
.activationData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.activationData-table-detail th,
.activationData-table-detail td {
  height: 2.5rem;
  padding: 0.45rem;
  border-color: #999999!important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999!important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle!important;
}
.activationData-table-detail td {
    font-size: 1rem;
}
.activationData-table-detail th:first-child,
.activationData-table-detail td:first-child {
  border-left: 1px solid;
}
.activationData-table-detail-select th,
.activationData-table-detail-select td {
  width: 140px;
  min-width: 126px;
}
.activationData-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.activationData-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.activationData-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>


// WEBPACK FOOTER //
// src/components/activationData.vue